import React, { CSSProperties } from 'react';
import { staticFileLocations } from 'urls';
import { resize } from 'util/cloudinary';
import styled from '@emotion/styled';

interface Props {
  companySlug?: string;
  imageURL?: string;
  style?: CSSProperties;
  width?: number | 'auto';
}

const BackgroundImg = styled.div`
  width: 100%;
  overflow: hidden;
  padding-bottom: 20%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export default function Banner({ imageURL, style }: Props) {
  const backgroundImage = resize(imageURL || staticFileLocations.defaultCompanyImage, { width: 'auto' });
  return (
    <BackgroundImg
      style={{
        ...style,
        backgroundImage: `url(${backgroundImage})`,
      }}
    />
  );
}
